module.exports ={
  title: ['结汇下发','Settle& Disb'],
  settlAmt_label: ['结汇金额：','Settlement amount：'],
  frozenSettlAmt_label: ['结汇冻结金额：','Frozen settlement amount：'],
  uploadSettlDisbTemp_label: ['上传结汇下发模板：','Upload settle& disb template：'],
  uploadSettlDisbTemp_placeholder: ['请上传结汇下发模板','upload settle& disb template'],
  downloadSettlDisbTemp: ['下载结汇下发模板','Download settle& disb template'],
  initSettlDisb: ['发起结汇下发','Initiate settle& disb'],
  downloadErrDisbDtl: ['下载错误下发明细','Download error disb details'],
  batchStatus_label: ['批次状态：','Batch status：'],
  search: ['查询','Inquiry'],
  export: ['导出','Export'],
  yuan: ['元','CNY'],
  merchantNumber: ['商户号','Merchant number'],
  merchantNumber_label: ['商户号：','Merchant number：'],
  merchantNumber_placeholder: ['请输入商户号','enter merchantNumber'],
  merchantName: ['商户名称','Merchant name'],
  merchantName_label: ['商户名称：','Merchant name：'],
  merchantName_placeholder: ['请输入商户名称','enter merchantName'],
  all: ['全部','all'],
  transEndDate_label: ['交易完成日期：','Trans Comp Time：'],
  start_date: ['开始日期','start date'],
  end_date: ['结束日期','end date'],
  to: ['至','To'],
  historySettDisbTrans: ['结汇下发历史交易记录','Historical Settle& Disb Transactions'],
  disbBatchNo: ['下发批次号','Disb batch No'],
  sumNumber: ['下发总笔数','Total disb items'],
  sumAmount: ['下发总金额','Total disb amt'],
  successNumber: ['成功笔数','Successful items'],
  successAmount: ['成功金额','Successful amount'],
  createdTime: ['交易创建时间','Trans create time'],
  finishTime: ['交易完成时间','Trans completion time'],
  batchStatus: ['批次状态','Batch status'],
  operation: ['操作','Operation'],
  payment: ['付款','Payment'],
  details: ['详情','Details'],
  disbAmount_label: ['下发金额：','Disbursement amount：'],
  pay_pwd_label: ['支付密码：','Pay_pwd：'],
  pay_pwd_placeholder: ['请输入支付密码','enter pay_pwd'],
  submit: ['确定','Submit'],
  disbSuccess: ['结汇下发成功发起，请及时操作付款～','settlement disb. successfully initiated, please proceed with payment timely~'],
  disbError: ['提交失败，上传结汇下发明细有误，请下载错误下发明细进行修改，重新上传','Submission failed. There is an error in the uploaded settlement disb. details. Please download the error disb. details to modify and re-upload.'],
  paySuccess: ['付款成功～','Pay succeeded～'],
  disbTrans: ['结汇下发交易','Settlement disb. trans'],
  disbTransError: ['请稍后重试','Try again later'],
  null: ['暂无数据','N/A'],
  detail: {
    title: ['结汇下发 - 详情','Settle& Disb - Details'],
    backList: ['返回列表','Back List'],
    disbStatus_label: ['下发状态：','Diab. status：'],
    all: ['全部','all'],
    search: ['查询','Inquiry'],
    export: ['导出','Export'],
    settDisbBatchInfo: ['结汇下发批次详情','Settlement disb. batch details'],
    disbNo: ['下发编号','Disb No'],
    orderNumber: ['订单编号','Order NO'],
    payeeType: ['收款人类型','Payee type'],
    payeeName: ['收款人名称','Payee name'],
    payeeAccountNo: ['银行账号','Bank account NO'],
    payeeBankName: ['开户行名称','Issuing bank name'],
    payeeBankNumber: ['联行号','Interbank code'],
    amount: ['交易金额','Trans. amount'],
    disbStatus: ['下发状态','Disb. status'],
    message: ['交易描述','Trans. description'],
    pay_pwd_placeholder: ['请输入支付密码','enter pay_pwd'],
    disbTrans: ['结汇下发详情交易','Settlement disb. Details trans'],
    disbTransError: ['请稍后重试','Try again later'],
  }
}